import { Flex } from 'antd';

import styled from '@emotion/styled';

export const Container = styled(Flex)`
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 30px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.colors.text400};
  font-size: 12px;
  margin-bottom: 24px;
`;
